import React, { useEffect,useState } from 'react'
import { PiCaretDoubleLeft,PiCaretLeft,PiCaretDoubleRight,PiCaretRight, PiMagnifyingGlassLight} from "react-icons/pi";
import { useRef } from 'react';
import { PiDotsThreeVertical} from "react-icons/pi";
import LoadingIcons from 'react-loading-icons';
import { createPopup } from 'coaz-ui';
import { getScreenSize} from '../constants'

const UserItems = ({onSelect,search,buttons,version}) => {
    const [users,setUsers] = useState([]);
    const [pageNo,setPageNo] = useState(0);
    const [pageSize,setPageSize] = useState(0);
    const [totalElements,setTotalElements] = useState(0);
    const [totalPages,setTotalPages] = useState(0);
    const [last,setLast] = useState(true);
    const [page,setPage] = useState({
        pageNo:0,
        pageSize:10
    })
    const [loading,setLoading] = useState(false);
    const [searchKey,setSearchKey] = useState('');
    const searchKeyRef = useRef('');

    const handleChange = async (e) => {
        let value = e.target.value;
        setSearchKey(value);
        searchKeyRef.current = value;
        handleFirst(e);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleFirst(e);
        }
    };

    const handleFirst = (e) => {
        if(e) e.preventDefault();
        setPage({...page, pageNo: 0});
    }

    const handlePrevious = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo > 0) {
            setPage({...page, pageNo: page.pageNo - 1});
        }
    }

    const handleNext = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo < totalPages - 1) {
            setPage({...page, pageNo: page.pageNo + 1});
        }
    }

    const handleLast = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo < totalPages - 1 && !last) {
            setPage({...page, pageNo: totalPages - 1});
        }
    }

    useEffect(() => {
        (async () => {
            if(!search) return;
            setLoading(true);
            await search(searchKey,page)
            .then((response) => {
                if(searchKey === searchKeyRef.current) {
                    if(response && response.users) {
                        setUsers(response.users);
                        setPageNo(response.pageNo);
                        setPageSize(response.pageSize);
                        setTotalElements(response.totalElements);
                        setTotalPages(response.totalPages);
                        setLast(response.last);
                    } else {
                        setUsers([]);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                setUsers([]);
            })
            setLoading(false);
        })()
    },[page,version])
  return (
    <div className='flex flex-col w-full h-auto space-y-2'>
        <div onKeyDown={handleKeyDown} 
            className='flex flex-row w-full overflow-hidden border rounded-full h-fit bg-'>
            <button onClick={(e) => handleFirst && handleFirst(e)}  className='flex w-10 h-10 justify-center shrink-0 items-center text-[rgb(170,170,170)]'>
                <PiMagnifyingGlassLight size={20}/>
            </button>
            <input
                type='text' 
                name='username'
                value={searchKey}
                onChange={handleChange}
                placeholder='Search...'
                autoComplete='off'
                className='flex w-full h-10 p-2 overflow-hidden text-sm focus:outline-none whitespace-nowrap'
            />
        </div>
         {users  && totalElements >  pageSize &&
            <div className='flex flex-col items-center justify-center w-full space-y-2 overflow-hidden ml:flex-row h-fit ml:justify-between ml:space-y-0 ml:space-x-2'>
                <p className='flex shrink-0 text-xs font-helveticaNeueRegular text-[rgb(145,145,145)] tracking-wider'>
                    {`Showing ${users && users.length > 0?(pageNo * pageSize)+1:0} to ${((pageNo * pageSize)+users.length)} of ${totalElements}`}
                </p>
                <div className='flex flex-row w-fit h-fit shrink-0 space-x-2 text-[rgb(68,71,70)]'> 
                    <button 
                        disabled={!pageNo || pageNo < 1}
                        onClick={(e) => handleFirst && handleFirst(e) }
                        className={`flex w-10 h-10 ${pageNo < 1?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                    >
                        <PiCaretDoubleLeft size={16} className='flex m-auto'/>
                    </button>
                    <button 
                        disabled={!pageNo || pageNo < 1}
                        onClick={(e) => handlePrevious && handlePrevious(e)}
                        className={`flex w-10 h-10 ${pageNo < 1?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                    >
                        <PiCaretLeft size={16} className='flex m-auto'/>
                    </button>
                    <button 
                        disabled={last}
                        onClick={(e) => handleNext && handleNext(e)}
                        className={`flex w-10 h-10 ${last?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                    >
                        <PiCaretRight size={16} className='flex m-auto'/>
                    </button>
                    <button 
                        disabled={last}
                        onClick={(e) => handleLast && handleLast(e)}
                        className={`flex w-10 h-10 ${last?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                    >
                        <PiCaretDoubleRight size={16} className='flex m-auto'/>
                    </button>
                </div>
            </div>
        }
        {loading?
            <div className='flex items-center justify-center w-full h-full'>
                <LoadingIcons.SpinningCircles width={64} height={64} fill="rgb(0,175,240)"/>
            </div>:
            users && users.length > 0 &&
            <div className='flex flex-col w-full h-auto space-y-2'>
                {users.map((user,i) => <UserItem key={i} user={user} onSelect={onSelect} buttons={buttons} page={page} setPage={setPage}/>)}
            </div>
        }
        
    </div>
  )
}

export default UserItems

const UserItem = ({user,onSelect,buttons,page,setPage}) => {
    const [highlighted,setHighlighted] = useState(false);
    const moreRef = useRef(null);

    return (
        <div className='flex flex-row w-full h-auto overflow-hidden'>
            {user &&
            <div  onMouseEnter={(e) => setHighlighted(true)} 
                onMouseLeave={(e) => setHighlighted(false)} 
                className='flex flex-row w-full p-2 items-center justify-between hover:bg-[rgba(0,0,0,.04)] rounded-full overflow-hidden'>
                <div onClick={(e) => {
                        e.preventDefault();
                        onSelect && onSelect(user);
                    }}
                    className={`flex flex-row w-full items-center space-x-2 overflow-hidden ${onSelect && 'cursor-pointer'}`}>
                    <p className='flex w-10 h-10 shrink-0 rounded-full text-xl font-jostMedium items-center justify-center text-white bg-[rgb(0,175,240)]'>
                        {user.firstname.charAt(0).toUpperCase()+user.lastname.charAt(0).toUpperCase()}
                    </p>
                    <div className='flex flex-col w-full overflow-hidden h-fit'>
                        <p className={`text-sm text-[rgb(68,71,70)] font-helveticaNeueRegular whitespace-nowrap overflow-hidden overflow-ellipsis capitalize`}>
                            {`${user.firstname.toLowerCase()} ${user.lastname.toLowerCase()}`}
                        </p>
                        <div className='flex flex-row w-full space-x-2'>
                            {user.userType &&
                                <p className='text-xs text-[rgb(145,145,145)] whitespace-nowrap overflow-hidden overflow-ellipsis capitalize'>
                                    {user.userType.name}
                                </p>
                            }
                            {user.status && <p className={`text-xs ${user.status === 'ACTIVE'?'text-green-600':user.status === 'OTP'?'text-yellow-400':'text-[rgb(145,145,145)]'} font-helveticaNeueRegular whitespace-nowrap overflow-hidden overflow-ellipsis capitalize`}>
                                {user.status.toLowerCase()}
                            </p>}
                        </div>
                    </div>
                </div>
                    {(highlighted || getScreenSize() === 'xs') && buttons && buttons.length > 0 &&
                        <button ref={moreRef}
                            onClick={(e) => {
                                e.stopPropagation();
                                createPopup({
                                    buttonRef:moreRef,
                                    Component:
                                        <div className='flex flex-col w-fit h-fit text-left text-sm font-[arial] text-[rgb(68,71,70)]'>
                                            {buttons.map((button,i) => 
                                                <button 
                                                    key={i}
                                                    onClick={(e) => {
                                                        button.handler && button.handler(user,page,setPage)}
                                                    }
                                                    className='flex flex-row w-full px-2 h-8 space-x-2 items-center hover:bg-[rgb(234,235,239)] shrink-0'>
                                                    {button.Icon && <button.Icon size={20} className='flex shrink-0'/>}
                                                    {button.name && <p className='w-full overflow-hidden text-left whitespace-nowrap overflow-ellipsis'>
                                                        {button.name}
                                                    </p>}
                                                </button>
                                            )}
                                        </div>
                                })
                            }}
                            className='flex w-10 h-10 items-center justify-center shrink-0 hover:bg-[rgba(0,0,0,.06)] rounded-full'>
                            <PiDotsThreeVertical size={20} />
                        </button>
                    }
            </div>}
        </div>
    )
}